import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const NUMBER = "393927715932";
const MESSAGE = "Salve, ho visto il vostro sito e vorrei capire se il saldo e stralcio è possibile per la mia situazione.";
const HREF = `https://wa.me/${NUMBER}?text=${encodeURIComponent(MESSAGE)}`;

export default function WhatsAppButton() {
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    const check = () => setChatOpen(document.body.classList.contains("chat-open"));
    check();
    const mo = new MutationObserver(check);
    mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => mo.disconnect();
  }, []);

  return (
    <motion.a
      href={HREF}
      target="_blank"
      rel="noreferrer noopener"
      data-testid="whatsapp-floating-btn"
      aria-label="Scrivi su WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ opacity: chatOpen ? 0 : 1, scale: chatOpen ? 0.6 : 1 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      className="whatsapp-fab fixed bottom-24 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center hover:bg-[#1DA851]"
      style={{ transition: "background-color 200ms ease", pointerEvents: chatOpen ? "none" : "auto" }}
    >
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.28c-.28-.14-1.65-.81-1.9-.9-.26-.09-.44-.14-.63.14-.19.28-.72.9-.88 1.09-.16.19-.32.21-.6.07-.28-.14-1.17-.43-2.23-1.37-.83-.74-1.38-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.47-.63-.48h-.54c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.35 0 1.39 1.01 2.73 1.15 2.92.14.19 1.99 3.04 4.83 4.26.68.29 1.2.47 1.61.6.68.22 1.29.19 1.78.11.54-.08 1.65-.67 1.88-1.32.23-.65.23-1.21.16-1.32-.07-.11-.26-.19-.54-.33zM16 3C8.82 3 3 8.82 3 16c0 2.34.62 4.53 1.72 6.44L3 29l6.75-1.72A12.93 12.93 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3zm0 23.63c-2.06 0-4-.55-5.68-1.5l-.41-.24-4 1.02 1.07-3.9-.27-.42A10.6 10.6 0 0 1 5.37 16 10.63 10.63 0 0 1 16 5.37 10.63 10.63 0 0 1 26.63 16 10.63 10.63 0 0 1 16 26.63z"/>
      </svg>
    </motion.a>
  );
}
